import { AlcoholInfo } from '../types/AlcoholInfo';
import { AlcoholType } from '../types/AlcoholType';

export const Alcohols: Record<AlcoholType, AlcoholInfo> = {
    largeBeer: {
        label: 'Large beer 0.5 l',
        icon: window.alculatorGlobals.imagesDir + '/beer_mug.svg',
        ml: 500,
        alcPercentage: 5,
    },
    smallBeer: {
        label: 'Small beer 0.3 l',
        icon: window.alculatorGlobals.imagesDir + '/beer_glass.svg',
        ml: 300,
        alcPercentage: 5,
    },
    wine: {
        label: 'Wine 0.1 l',
        icon: window.alculatorGlobals.imagesDir + '/wine.svg',
        ml: 100,
        alcPercentage: 13,
    },
    shot: {
        label: 'Shot 5 cl',
        icon: window.alculatorGlobals.imagesDir + '/vodka.svg',
        ml: 50,
        alcPercentage: 40,
    },
};
